module.exports = __webpack_public_path__ + "img/default_cover.1918ae98.png";